export const RATING_STYLES = {
  "A+": "bg-green-500/20 text-green-400 border-green-500/50",
  A: "bg-green-500/10 text-green-400 border-green-500/30",
  "B+": "bg-blue-500/20 text-blue-400 border-blue-500/50",
  B: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  "C+": "bg-yellow-500/20 text-yellow-400 border-yellow-500/50",
  C: "bg-yellow-500/10 text-yellow-400 border-yellow-500/30",
  PASS: "bg-zinc-800 text-zinc-400 border-zinc-700",
};

export const RATINGS_ORDER = ["A+", "A", "B+", "B", "C+", "C", "PASS"];
